import mitt from "mitt";
import Util from "@/helper/Utility.js";

export function PdpaModalController () {
    this.isRequireAccept = false;
    this.tag = null;
    this.type = null;
    this.version = null;
    this.btnAccept = null;
    this.btnCancel = null;

    this.busModal = mitt();
    //callback
    this.callbackAccept = null;
    this.callbackReject = null;
    this.callbackHidden = null;
    //related modal
    this.alertModal = null;
    this.loadingModal = null;
    this.isShowClose = true;

    //#region setter
    this.clearModal = function () {
        this.isRequireAccept = false;
        this.title = null;
        this.tag = null;
        this.type = null;
        this.version = null;
        this.btnAccept = null;
        this.btnReject = null;
        this.callbackAccept = null;
        this.callbackReject = null;
        this.callbackHidden = null;
        this.showConfirmBtn = false;
        return this;
    };
    this.setIsRequireAccept = function (isRequireAccept) {
        this.isRequireAccept = isRequireAccept;
        return this;
    };
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.setType = function (type) {
        this.type = type;
        return this;
    };
    this.setVersion = function (version) {
        this.version = version;
        return this;
    };
    this.setBtnAccept = function (btnAccept) {
        this.btnAccept = btnAccept;
        return this;
    };
    this.setBtnReject = function (btnReject) {
        this.btnReject = btnReject;
        return this;
    };
    this.setAlertModal = function(alertModal) {
        this.alertModal = alertModal;
    };
    this.setLoadingModal = function(loadingModal) {
        this.loadingModal = loadingModal;
    };
    this.changeToConfirmBtn = function(state) {
        this.showConfirmBtn = state;
        return this;
    };
    this.setShowCode = function(isShow) {
        this.isShowClose = isShow;
        return this;
    };
    //#endregion setter

    //#region control
    this.show = function() {
        console.log("====show controller===");

        var config = {
            title: this.title,
            isRequireAccept: this.isRequireAccept,
            type: this.type,
            version: this.version,
            btnAccept: this.btnAccept,
            btnReject: this.btnReject,
            tag: this.tag,
            showConfirmBtn: this.showConfirmBtn,
            isShowClose: this.isShowClose,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion control
    //#region event
    this.onClickAccept = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackAccept = callback;
        }
    },
    this.sendCallbackAccept = function(data) {
        if (Util.isFunction(this.callbackAccept)) {
            this.callbackAccept(data);
        }
    };

    this.onClickReject = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackReject = callback;
        }
    },
    this.sendCallbackReject = function(data) {
        if (Util.isFunction(this.callbackReject)) {
            this.callbackReject(data);
        }
    };

    this.onHidden = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function(data) {
        if (Util.isFunction(this.callbackHidden)) {
            this.callbackHidden(data);
        }
    };
    //#endregion event
}
